import type { AuditCategory, OrganisationPolicies } from "../admin-types";
import type { Ctx, OrgContext } from "./context";
import type { StoredOrganisation } from "./state";

/** The mock's organisation policies and audit log (FR-ADMIN-012, 047, 060, 111). */

export const DEFAULT_POLICIES: OrganisationPolicies = {
  memberProjectAccess: "view_all",
  projectCreation: "members",
  sessionMaxHours: undefined,
};

export function policiesOf(org: StoredOrganisation): OrganisationPolicies {
  const stored = org.policies;
  return stored === undefined
    ? { ...DEFAULT_POLICIES }
    : {
        memberProjectAccess: stored.memberProjectAccess,
        projectCreation: stored.projectCreation,
        sessionMaxHours: stored.sessionMaxHours,
      };
}

/** Appends an admin action to the log (FR-ADMIN-060). */
export function recordAudit(
  ctx: Ctx,
  context: OrgContext,
  category: AuditCategory,
  action: string,
  target: { type: string; id: string; name: string },
  detail: Record<string, unknown>,
): void {
  ctx.state.audit ??= [];
  ctx.state.audit.push({
    id: `audit-${ctx.token().slice(0, 12)}`,
    organisationId: context.org.id,
    occurredAt: ctx.now(),
    actorId: context.user.id,
    actorName: context.user.name,
    category,
    action,
    targetType: target.type,
    targetId: target.id,
    targetName: target.name,
    detail,
  });
}
